import React from "react";
import "../styles/TextBlockStyles.scss";

const TextBlockLims = () => {
  return (
    <div className="text-block-lims">
      <h1>
        <span className="brand-name">LIMS IT-Lab</span> — упростит процесс прохождения проверок,
        аккредитации и оптимизирует работу сотрудников в Вашей Лаборатории
      </h1>
    </div>
  );
};

export default TextBlockLims;
